import React, { useState, useContext, useEffect, useCallback, useMemo, useRef } from "react";
import { NavLink as Linkto, useHistory, useLocation } from "react-router-dom";
import Draggable from "react-draggable";
import styled from "styled-components/macro";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";
import Moment from "moment";
import "moment/locale/es";
Moment.locale("es");

import {
  Divider as MuiDivider,
  Grid,
  Typography,
  FormControl,
  Button,
  IconButton,
  TextField,
  InputLabel,
  MenuItem,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Paper as MuiPaper,
  InputAdornment,
  DialogContentText,
  Checkbox,
  FormControlLabel,
  Label,
  FormGroup,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  Radio
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { actions } from "../../redux/actions/customerBusinessActions";
import { actions as processorsActions } from "../../redux/actions/processorsActions";
import { AuthContext } from "../../redux/store/auth-context";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

import { spacing } from "@material-ui/system";

const SUBSCRIPTION_PAGOPAR_INCOMPATIBLE =
  "Las suscripciones no son compatibles con métodos de pago vía Pago Par (Pagopar). Seleccione otra configuración (por ejemplo Bancard / multibuy) o quite el producto Suscripción del plan.";
import NumberFormat from "react-number-format";

const Divider = styled(MuiDivider)(spacing);
const Paper = styled(MuiPaper)(spacing);
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  title: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    padding: "0.5rem 1rem",
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    width: "100%",
  },
  odd: {
    backgroundColor: "#c6c6c6",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  attr: {
    display: "inline-block",
  },
  attrContainer: {
    position: "relative",
    maxWidth: "400px",
    display: "inline-block",
    padding: 15,
  },
  attrImage: {
    width: 150,
  },
  attrOverlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: "100%",
    width: "100%",
    opacity: 0,
    transition: ".3s ease",
    backgroundColor: "black",
    "&:hover": {
      opacity: 0.7,
    },
  },
  attrIcon: {
    color: "white",
    fontSize: 12,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -68%)",
    textAlign: "center",
    textDecoration: "none",
    "&:hover": {
      color: "#eee",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    width: "95%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  active: {
    display: "block",
  },
  inactive: {
    display: "none",
  },
  label: {
    fontSize: "10px !important",
    color: "rgba(0, 0, 0, 0.38)",
  },
}));

function CustomerBusinessEdit(props) {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const redData = useSelector((state) => state.customerBusinessReducer);
  const processorsData = useSelector((state) => state.processorsReducer);
  
  const businessId = props.match.params.id ? props.match.params.id : false;
  const filterApplieds = location.state?.datas;
  const backUrl = location.state?.backUrl;
  const userData = location.state?.userData;

  // State variables
  const [rows, setRows] = useState("");
  const [plans, setPlans] = useState("");
  const [open, setOpen] = useState(false);
  const [submited, setSubmited] = useState(false);
  const [pressButtonSubmit, setPressButtonSubmit] = useState(false);
  const [userId, setUserId] = useState(false);
  const [businessFantasy, setBusinessFantasy] = useState("");
  const [businessSocial, setBusinessSocial] = useState("");
  const [businessRuc, setBusinessRuc] = useState("");
  const [api, setApi] = useState(false);
  const [plan, setPlan] = useState("");
  const [planPeriod, setPlanPeriod] = useState("");
  const [planFee, setPlanFee] = useState("");
  const [planPrice, setPlanPrice] = useState("");
  const [productsPlan, setProductsPlan] = useState([]);
  const [productsPlanInitial, setProductsPlanInitial] = useState("");
  const [productsPlanValue, setProductsPlanValue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFeeError, setIsFeeError] = useState(false);
  const [payloadData, setPayloadData] = useState("");
  
  // New state for accreditation and manual crediting
  const [accreditationType, setAccreditationType] = useState("Automatico");
  const [manualCrediting, setManualCrediting] = useState(false);
  const [minimumBalance, setMinimumBalance] = useState("0");
  const [daysToCredit, setDaysToCredit] = useState([]);
  const [accreditationFrequency, setAccreditationFrequency] = useState("Principio de mes");
  
  // Bancard modification state
  const [bancardModification, setBancardModification] = useState("No Modifica");
  
  // Processors state
  const [selectedConfigurations, setSelectedConfigurations] = useState({});
  const [processorCommissions, setProcessorCommissions] = useState({});
  const [processorAvailability, setProcessorAvailability] = useState({});
  const [selectedProcessors, setSelectedProcessors] = useState([]);
  
  // Original data state for change detection
  const [originalData, setOriginalData] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);
  
  // Days of week for custom accreditation
  const days_week = [
    { id: 1, name: "Lunes" },
    { id: 2, name: "Martes" },
    { id: 3, name: "Miércoles" },
    { id: 4, name: "Jueves" },
    { id: 5, name: "Viernes" },
    { id: 6, name: "Sábado" },
    { id: 7, name: "Domingo" }
  ];
  
  const isMountedRef = useRef(true);

  // Suscripción exige Bancard multibuy: quitar Pago Par si se marca el producto Suscripción
  useEffect(() => {
    if (!productsPlanInitial || !Array.isArray(productsPlanInitial)) return;
    const hasSub = (productsPlan || []).some((pid) => {
      const pr = productsPlanInitial.find((x) => x.id == pid);
      return pr && (pr.name === "Suscripción" || pr.name === "Suscripcion");
    });
    if (!hasSub) return;
    setSelectedConfigurations((prev) => {
      const next = { ...prev };
      let changed = false;
      Object.keys(next).forEach((k) => {
        if (String(next[k] || "").toLowerCase() === "pagopar") {
          next[k] = "";
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [productsPlan, productsPlanInitial]);

  // Function to detect changes between original and current data
  const detectChanges = useCallback((currentData) => {
    if (!originalData) return false;
    
    // Compare basic fields
    const basicFieldsChanged = 
      currentData.businessfantasy !== originalData.businessfantasy ||
      currentData.businesssocial !== originalData.businesssocial ||
      currentData.businessruc !== originalData.businessruc ||
      currentData.api !== originalData.api ||
      currentData.plan !== originalData.plan ||
      currentData.plan_period !== originalData.plan_period ||
      currentData.plan_fee !== originalData.plan_fee ||
      currentData.minimum_credit_balance !== originalData.minimum_credit_balance ||
      currentData.manual_crediting !== originalData.manual_crediting ||
      currentData.accreditation_type !== originalData.accreditation_type ||
      currentData.accreditation_frequency !== originalData.accreditation_frequency ||
      currentData.bancard_modification !== originalData.bancard_modification;
    
    // Compare products plan
    const currentProductsPlan = [...(currentData.products_plan || [])].sort((a, b) => a - b);
    const originalProductsPlan = [...(originalData.products_plan || [])].sort((a, b) => a - b);
    const productsChanged = JSON.stringify(currentProductsPlan) !== JSON.stringify(originalProductsPlan);
    
    
    // Compare processors
    const currentProcessors = currentData.processors || [];
    const originalProcessors = originalData.processors || [];
    
    // Sort processors by id for comparison
    const sortedCurrent = [...currentProcessors].sort((a, b) => a.id - b.id);
    const sortedOriginal = [...originalProcessors].sort((a, b) => a.id - b.id);
    
    const processorsChanged = JSON.stringify(sortedCurrent) !== JSON.stringify(sortedOriginal);
    
    // Compare product prices and fees
    const productPricesChanged = 
      currentData.cobro_rápido_price !== originalData.cobro_rápido_price ||
      currentData.cobro_rápido_fee !== originalData.cobro_rápido_fee ||
      currentData.suscripción_price !== originalData.suscripción_price ||
      currentData.suscripción_fee !== originalData.suscripción_fee ||
      currentData.catálogo_price !== originalData.catálogo_price ||
      currentData.catálogo_fee !== originalData.catálogo_fee;
    
    // Compare processor commissions, availability, and configurations
    // Normalize data types for comparison (convert strings to numbers where appropriate)
    const normalizeProcessorCommissions = (commissions) => {
      const normalized = {};
      Object.keys(commissions || {}).forEach(key => {
        const value = commissions[key];
        // Try to convert to number if it looks like a number
        normalized[key] = (!isNaN(value) && value !== '') ? parseFloat(value) : value;
      });
      return normalized;
    };
    
    const normalizedCurrentCommissions = normalizeProcessorCommissions(processorCommissions);
    const normalizedOriginalCommissions = normalizeProcessorCommissions(originalData.processorCommissions || {});
    
    const processorCommissionsChanged = JSON.stringify(normalizedCurrentCommissions) !== JSON.stringify(normalizedOriginalCommissions);
    const processorAvailabilityChanged = JSON.stringify(processorAvailability) !== JSON.stringify(originalData.processorAvailability || {});
    const selectedConfigurationsChanged = JSON.stringify(selectedConfigurations) !== JSON.stringify(originalData.selectedConfigurations || {});
    
    const hasChanges = basicFieldsChanged || productsChanged || processorsChanged || productPricesChanged || 
                      processorCommissionsChanged || processorAvailabilityChanged || selectedConfigurationsChanged;
    
    return hasChanges;
  }, [originalData, processorCommissions, processorAvailability, selectedConfigurations]);

  // Load business data for editing
  useEffect(() => {
    if (businessId) {
      dispatch(
        actions({
          url: `customer_business/?id=${businessId}`,
          token: auth.token,
          action: "list",
        })
      );
    }
  }, [auth.token, businessId]);

  // Load processors data
  useEffect(() => {
    dispatch(
      processorsActions({
        url: "processors/",
        token: auth.token,
        action: "list",
      })
    );
  }, [auth.token]);

  // Load business data with processors info
  useEffect(() => {
    if (businessId && auth.token) {
        // Make direct API call to get the complete data including plan_processors
        const apiUrl = `${process.env.REACT_APP_TEOPAGOS_URI}/admin/customer_business/?id=${businessId}`;
      
      fetch(apiUrl, {
        headers: {
          'Authorization': `Token ${auth.token}`,
          'Content-Type': 'application/json',
        },
      })
      .then(response => response.json())
      .then(data => {
        // Store the data in component state for use in the form
        if (data.plan_processors) {
          const existingConfigurations = {};
          const existingCommissions = {};
          const existingAvailability = {};
          
          data.plan_processors.forEach(planProcessor => {
            if (planProcessor.processor) {
              const processorName = planProcessor.processor.name.toLowerCase();
              const configuration = planProcessor.processor.configuration || 'directo';
              
              existingConfigurations[processorName] = configuration;
              existingCommissions[processorName] = planProcessor.processor_commission || planProcessor.processor.fee;
              existingAvailability[processorName] = planProcessor.availability || planProcessor.processor.availability;
            }
          });
          
          setSelectedConfigurations(existingConfigurations);
          setProcessorCommissions(existingCommissions);
          setProcessorAvailability(existingAvailability);
        }
        
        // Set withdrawal section data
        if (data.rows && data.rows.results && data.rows.results.rows && data.rows.results.rows.length > 0) {
          const businessData = data.rows.results.rows[0];
          
          // Set accreditation type based on manual_crediting (boolean field)
          if (businessData.manual_crediting !== undefined) {
            // Handle both boolean and string values (true/false or "Yes"/"No")
            const isManual = businessData.manual_crediting === true || businessData.manual_crediting === "Yes" || businessData.manual_crediting === "yes";
            const accreditationType = isManual ? "Manual" : "Automatico";
            setAccreditationType(accreditationType);
          } else {
            // Default to Automatico if manual_crediting is not defined
            setAccreditationType("Automatico");
          }
          
          // Set minimum balance from minimum_credit_balance field (handle undefined)
          const minBalance = businessData.minimum_credit_balance !== undefined ? businessData.minimum_credit_balance : 0;
          setMinimumBalance(minBalance.toString());
          
          // For automatic crediting, check if there are custom days configured
          const isManual = businessData.manual_crediting === true || businessData.manual_crediting === "Yes" || businessData.manual_crediting === "yes";
          if (!isManual) {
            // Automatic crediting - check if there are custom days in customerbusiness_days_to_credit table
            if (businessData.days_to_credit && Array.isArray(businessData.days_to_credit) && businessData.days_to_credit.length > 0) {
              // Has custom days configured
              setAccreditationFrequency("Días personalizados");
              
              // Set the custom days
              const daysIds = businessData.days_to_credit.map(day => day.id || day);
              setDaysToCredit(daysIds);
            } else {
              // No custom days, use default "Principio de mes"
              setAccreditationFrequency("Principio de mes");
              setDaysToCredit([]); // Ensure empty array
            }
          } else {
            // Manual crediting - no need to set frequency or days
          }
        }
      })
      .catch(error => {
        console.error("Error fetching business data:", error);
      });
    }
  }, [businessId, auth.token]);

  // Process loaded data
  useEffect(() => {
    if (!isMountedRef.current) {
      return;
    }
    
    if (redData?.rows?.constructor == Object) {
      
      // Load business data from requirements (same as original CustomerBusiness.js)
      let datas_requirement = {};
      const initialReq = ["businessfantasy", "businessruc", "businesssocial", "businessactivity"];
      
      if (redData.rows?.requirements) {
        redData.rows.requirements
          ?.filter(
            (item) => initialReq.indexOf(item.requirement.field_name) > -1
          )
          ?.map((item) => {
            datas_requirement[item.requirement.field_name] = {
              id: item.id,
              status_general: item.status,
              requirement_id: item.requirement.id,
              field_label: item.requirement.field_label,
              field_type: item.requirement.field_type,
              field_name: item.requirement.field_name,
              order: item.requirement.order,
              created_at: item.created_at,
              updated_at: item.updated_at,
              parent: item.requirement.parent_id,
              comments: item.comments,
              value: item.value,
              attachments: item.attachments,
            };
          });
      }
      
      if (datas_requirement && Object.keys(datas_requirement).length > 0) {
        setBusinessFantasy(datas_requirement.businessfantasy?.value || "");
        setBusinessRuc(datas_requirement.businessruc?.value || "");
        setBusinessSocial(datas_requirement.businesssocial?.value || "");
      } else {
        setBusinessFantasy("");
        setBusinessRuc("");
        setBusinessSocial("");
      }

      setRows(redData.rows.rows);
      if (!userId) {
        setUserId(redData.rows.rows[0].id);
      }
      
      // Set other business data
      const businessData = redData.rows.rows[0];
      if (businessData) {
        setApi(businessData.api || false);
        setPlan(businessData.plan?.id || "");
        setPlanPeriod(businessData.plan?.period || "");
        setPlanFee(businessData.plan?.fee || "");
        setPlanPrice(businessData.plan?.price || "");
        
        // Set accreditation data - default to "Automatico" if not set
        setAccreditationType(businessData.accreditation_type || "Automatico");
        setManualCrediting(businessData.manual_crediting || false);
        setMinimumBalance(businessData.minimum_credit_balance?.toString() || "0");
        
        // Set bancard modification data
        setBancardModification(businessData.bancard_modification || "No Modifica");
        
        // Set custom days for accreditation
        console.log('=== CUSTOM DAYS DEBUG ===');
        console.log('businessData.days_to_credit:', businessData.days_to_credit);
        console.log('businessData.accreditation_frequency:', businessData.accreditation_frequency);
        console.log('businessData.manual_crediting:', businessData.manual_crediting);
        
        if (businessData.days_to_credit && Array.isArray(businessData.days_to_credit) && businessData.days_to_credit.length > 0) {
          // Has custom days configured
          console.log('Setting custom days:', businessData.days_to_credit);
          setAccreditationFrequency("Días personalizados");
          
          // Map day names to their IDs
          const daysIds = businessData.days_to_credit.map(dayName => {
            // If it's already a number (ID), use it
            if (typeof dayName === 'number') return dayName;
            
            // If it's an object with id property, use that
            if (typeof dayName === 'object' && dayName.id) return dayName.id;
            
            // Otherwise, find the day by name
            const dayObj = days_week.find(d => d.name === dayName);
            return dayObj ? dayObj.id : null;
          }).filter(id => id !== null);
          
          console.log('Setting daysToCredit with IDs:', daysIds);
          setDaysToCredit(daysIds);
        } else {
          // No custom days, use default "Principio de mes"
          console.log('No custom days found, setting to Principio de mes');
          setAccreditationFrequency("Principio de mes");
          setDaysToCredit([]); // Ensure empty array
        }
        
        // Set products plan - only include products that are actually part of the business
        if (redData.products_plan && redData.products_plan.length > 0) {
          const productIds = redData.products_plan.map(p => p.method.id);
          setProductsPlan(productIds);
        } else {
          setProductsPlan([]);
        }
        setProductsPlanInitial(redData.products_plan_initial || []);
        
        // Load existing processor configurations from plan_processors
        if (redData.plan_processors && redData.plan_processors.length > 0) {
          const existingConfigurations = {};
          const existingCommissions = {};
          const existingAvailability = {};
          
          redData.plan_processors.forEach(planProcessor => {
            if (planProcessor.processor) {
              const processorName = planProcessor.processor.name.toLowerCase();
              const configuration = planProcessor.processor.configuration || 'directo';
              
              // Set the configuration
              existingConfigurations[processorName] = configuration;
              
              // Set the commission (use the plan_processor commission, not the default processor fee)
              existingCommissions[processorName] = planProcessor.processor_commission || planProcessor.processor.fee;
              
              // Set the availability
              existingAvailability[processorName] = planProcessor.availability || planProcessor.processor.availability_input || planProcessor.processor.availability;
            }
          });
          
          // Set the state with existing data
          setSelectedConfigurations(existingConfigurations);
          setProcessorCommissions(existingCommissions);
          setProcessorAvailability(existingAvailability);
        }
        
        // Set products plan values
        if (redData.products_plan_initial) {
          let value = Object.assign(
            {},
            ...redData.products_plan_initial.map((product) => ({
              [product?.name.toLowerCase().replaceAll(" ", "_").concat("_price")]:
                redData.products_plan?.find((p) => p.method?.id == product?.id)
                  ?.price || product?.price_plan,
              [product?.name.toLowerCase().replaceAll(" ", "_").concat("_fee")]:
                redData.products_plan?.find((p) => p.method?.id == product?.id)
                  ?.fee || product?.fee_plan,
            }))
          );
          console.log("=== PRODUCTS PLAN VALUE CREATED ===", value);
          setProductsPlanValue(value);
          
          // Store original data for change detection - use actual loaded data from redData
          console.log("=== ATTEMPTING TO STORE ORIGINAL DATA ===");
          console.log("redData.rows:", redData.rows);
          console.log("redData.rows.rows:", redData.rows?.rows);
          console.log("redData.rows.rows.length:", redData.rows?.rows?.length);
          
          if (redData.rows && redData.rows.rows && redData.rows.rows.length > 0) {
            const businessData = redData.rows.rows[0];
            console.log("businessData:", businessData);
            
            const originalDataToStore = {
              businessfantasy: datas_requirement.businessfantasy?.value || "",
              businesssocial: datas_requirement.businesssocial?.value || "",
              businessruc: datas_requirement.businessruc?.value || "",
              api: businessData.api || false,
              plan: businessData.plan?.id || "",
              plan_period: businessData.plan?.period || "",
              plan_fee: businessData.plan?.fee || "",
              minimum_credit_balance: businessData.minimum_credit_balance || 0,
              manual_crediting: businessData.manual_crediting || false,
              accreditation_type: businessData.accreditation_type || "Automatico",
              accreditation_frequency: businessData.accreditation_frequency || "Principio de mes",
              bancard_modification: businessData.bancard_modification || "No Modifica",
              products_plan: redData.products_plan ? redData.products_plan.map(p => p.method.id).sort((a, b) => a - b) : [],
              processors: [], // Will be populated when processors are processed
              ...value // Product prices and fees (use the value we just created)
            };
            
            // Add processor commissions to original data
            originalDataToStore.processorCommissions = { ...processorCommissions };
            originalDataToStore.processorAvailability = { ...processorAvailability };
            originalDataToStore.selectedConfigurations = { ...selectedConfigurations };
            
            setOriginalData(originalDataToStore);
          }
        }
      }
    }
  }, [redData]);

  // Update original data when processor commissions are loaded
  useEffect(() => {
    if (originalData) {
      const hasCommissions = Object.keys(processorCommissions).length > 0;
      const hasAvailability = Object.keys(processorAvailability).length > 0;
      const hasConfigurations = Object.keys(selectedConfigurations).length > 0;
      
      if (hasCommissions || hasAvailability || hasConfigurations) {
        let needsUpdate = false;
        const updatedOriginalData = { ...originalData };
        
        // Update processor commissions if not set
        if (hasCommissions && (!originalData.processorCommissions || Object.keys(originalData.processorCommissions).length === 0)) {
          updatedOriginalData.processorCommissions = { ...processorCommissions };
          needsUpdate = true;
        }
        
        // Update processor availability if not set
        if (hasAvailability && (!originalData.processorAvailability || Object.keys(originalData.processorAvailability).length === 0)) {
          updatedOriginalData.processorAvailability = { ...processorAvailability };
          needsUpdate = true;
        }
        
        // Update selected configurations if not set
        if (hasConfigurations && (!originalData.selectedConfigurations || Object.keys(originalData.selectedConfigurations).length === 0)) {
          updatedOriginalData.selectedConfigurations = { ...selectedConfigurations };
          needsUpdate = true;
        }
        
        if (needsUpdate) {
          setOriginalData(updatedOriginalData);
        }
      }
    }
  }, [processorCommissions, processorAvailability, selectedConfigurations, originalData]);

  // Load plans
  useEffect(() => {
    dispatch(
      actions({
        url: "plans/",
        token: auth.token,
        action: "list",
      })
    );
  }, [auth.token]);

  useEffect(() => {
    if (redData?.plans) {
      setPlans(redData.plans);
    }
  }, [redData]);

  // Effect to track changes in real-time and update hasChanges state
  useEffect(() => {
    console.log("=== CHANGE DETECTION EFFECT RUNNING ===");
    console.log("originalData:", originalData);
    console.log("productsPlanValue:", productsPlanValue);
    console.log("productsPlan state:", productsPlan);
    console.log("Current hasChanges:", hasChanges);
    console.log("processorCommissions:", processorCommissions);
    console.log("processorAvailability:", processorAvailability);
    console.log("selectedConfigurations:", selectedConfigurations);
    console.log("=== DAYS TO CREDIT DEBUG ===");
    console.log("daysToCredit state:", daysToCredit);
    console.log("accreditationFrequency:", accreditationFrequency);
    
    // Only run change detection if we have both original data and products plan value
    if (originalData && productsPlanValue) {
      // Create current data object from current state
      const currentData = {
        businessfantasy: businessFantasy || "",
        businesssocial: businessSocial || "",
        businessruc: businessRuc || "",
        api: api || false,
        plan: plan || "",
        plan_period: planPeriod || "",
        plan_fee: planFee || "",
        minimum_credit_balance: parseInt(minimumBalance) || 0,
        manual_crediting: manualCrediting || false,
        accreditation_type: accreditationType || "Automatico",
        accreditation_frequency: accreditationFrequency || "Principio de mes",
        bancard_modification: bancardModification || "No Modifica",
        products_plan: productsPlan,
        processors: [], // Will be updated when form is submitted
        ...productsPlanValue // Product prices and fees
      };
      
      console.log("=== CONSTRUCTED CURRENT DATA ===");
      console.log("currentData.products_plan:", currentData.products_plan);
      
      const changesDetected = detectChanges(currentData);
      console.log("=== CHANGES DETECTED ===", changesDetected);
      
      if (changesDetected !== hasChanges) {
        console.log("=== UPDATING hasChanges FROM", hasChanges, "TO", changesDetected, "===");
        setHasChanges(changesDetected);
      }
    } else if (originalData === null) {
      // If we don't have original data yet, set hasChanges to false
      if (hasChanges !== false) {
        console.log("=== SETTING hasChanges TO FALSE (no originalData) ===");
        setHasChanges(false);
      }
    }
    // If originalData exists but productsPlanValue doesn't, don't change hasChanges
  }, [
    businessFantasy, businessSocial, businessRuc, api, plan, planPeriod, planFee,
    minimumBalance, manualCrediting, accreditationType, accreditationFrequency,
    bancardModification, productsPlan, productsPlanValue, selectedConfigurations,
    processorCommissions, processorAvailability, originalData, detectChanges
  ]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (e) => {
    setOpen(false);
  };

  const calculatePrice = (products) => {
    let priceTotal = 0;
    let new_products = [...new Set(products)];
    new_products.map((product_id) => {
      let product = productsPlanInitial.find(
        (product) => product.id == product_id
      );
      let price = +document
        .getElementById(
          `${product?.name.toLowerCase().replaceAll(" ", "_")}_price`
        )
        ?.value.replaceAll(".", "");
      priceTotal += price;
    });
    setPlanPrice(priceTotal);
  };

  const validateNetCommissions = (formValues) => {
    if (!processorsData.processors) return true;
    
    let productCommission = 0;
    if (formValues && formValues.plan_fee !== undefined && formValues.plan_fee !== null) {
      const planFeeValue = typeof formValues.plan_fee === 'string' 
        ? parseFloat(formValues.plan_fee.replace(',', '.')) 
        : parseFloat(formValues.plan_fee);
      productCommission = planFeeValue || 0;
    }
    
    for (const [processorName, config] of Object.entries(selectedConfigurations)) {
      if (config && config !== '' && config !== 'ninguno') {
        const processor = processorsData.processors?.find(p => {
          const nameMatch = p.name.toLowerCase() === processorName;
          let configMatch = false;
          if (config === 'directo') {
            configMatch = !p.configuration || p.configuration.trim() === '';
          } else {
            configMatch = (p.configuration || '').toLowerCase() === config;
          }
          return nameMatch && configMatch;
        });
        
        if (processor) {
          const userCommission = processorCommissions[processorName];
          const processorCommission = userCommission !== undefined ? parseFloat(userCommission) : (processor.fee || 0);
          const netCommission = productCommission - processorCommission;
          
          if (netCommission < 0) {
            return false;
          }
        }
      }
    }
    return true;
  };

  // Handle success response
  useEffect(() => {
    if (!isMountedRef.current) return;
    
    if (pressButtonSubmit && redData.success === true) {
      setSubmited(true);
      setOpen(true);
      setUserId(redData.data_updated.user);
      
      // Redirect to customer business details page
      if (businessId) {
        history.push(`/customersbusiness/details/${businessId}`);
      } else {
        // If creating new business, redirect to the business details
        if (redData.data_updated && redData.data_updated.id) {
          history.push(`/customersbusiness/details/${redData.data_updated.id}`);
        } else {
          // Fallback to the back URL or customers list
          history.push(backUrl || '/customersbusiness');
        }
      }
      
    } else if (pressButtonSubmit && redData.success === false) {
      setSubmited(false);
      const message =
        "Algo salió mal en el servidor, verifique los campos y vuelva a intentarlo";

      alert(message);
    }
  }, [redData, pressButtonSubmit]);

  return (
    redData && (
      <React.Fragment>
        {(() => {
          return null;
        })()}
        <Helmet title="Editar negocio" />
        <Grid justify="space-between" container spacing={24}>
          <Grid item className={classes.title}>
            <Typography variant="h3" gutterBottom display="inline">
              <Tooltip title="Atras">
                <IconButton aria-label="Atras" component={Linkto} to={backUrl}>
                  <KeyboardArrowLeftIcon fontSize="large" />
                </IconButton>
              </Tooltip>
              {rows && rows?.business_name}
            </Typography>
          </Grid>
        </Grid>

        <Divider my={6} />

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Paper p={10}>
              {productsPlanValue && productsPlanInitial ? (
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    user: userId,
                    businessfantasy: businessFantasy || "",
                    businesssocial: businessSocial || "",
                    businessruc: businessRuc || "",
                    api: api,
                    plan: plan,
                    plan_period: planPeriod,
                    plan_fee: planFee,
                    minimum_credit_balance: parseInt(minimumBalance) || 0,
                    manual_crediting: manualCrediting,
                    accreditation_type: accreditationType,
                    accreditation_frequency: accreditationFrequency,
                    bancard_modification: bancardModification,
                    store_id: "",
                    store_branch: "",
                    store_name: "",
                    days_to_credit: daysToCredit,
                    products_plan: productsPlan,
                    processors: [],
                    ...productsPlanValue
                  }}
                  validationSchema={Yup.object().shape({
                    businessfantasy: Yup.string().required("Debe ingresar Nombre Fantasía"),
                    businesssocial: Yup.string().required("Debe ingresar Razón Social"),
                    businessruc: Yup.string()
                      .required("Debe ingresar RUC")
                      .matches(/^\d{5,8}-\d{1}/, "El ruc debe seguir el siguiente formato 80012345-6"),
                    products_plan: Yup.array().min(1, "Debe seleccionar por lo menos un producto"),
                    processors: Yup.mixed().test(
                      "at-least-one-processor-selected",
                      "Debe seleccionar al menos un procesador diferente a 'Ninguno'",
                      function(value) {
                        const hasValidProcessor = Object.values(selectedConfigurations).some(config => 
                          config && config !== '' && config !== 'ninguno'
                        );
                        return hasValidProcessor;
                      }
                    ),
                    accreditation_type: Yup.string()
                      .required("Debe seleccionar un tipo de acreditación")
                      .test(
                        "accreditation-type-required",
                        "Debe seleccionar un tipo de acreditación",
                        function(value) {
                          return value && value !== '';
                        }
                      ),
                    minimum_credit_balance: Yup.number()
                      .when("accreditation_type", {
                        is: "Manual",
                        then: Yup.number()
                          .transform((value, originalValue) => {
                            if (typeof originalValue === 'string') {
                              return parseFloat(originalValue.replace(/\./g, ''));
                            }
                            return value;
                          })
                          .min(100000, "El saldo mínimo debe ser al menos 100,000 Gs cuando se selecciona acreditación Manual")
                          .required("Debe ingresar un saldo mínimo cuando se selecciona acreditación Manual"),
                        otherwise: Yup.number().min(0)
                      }),
                  })}
                  onSubmit={async (
                    values,
                    { setErrors, setStatus, setSubmitting }
                  ) => {
                    console.log("=== EDIT FORM SUBMISSION STARTED ===");
                    console.log("=== FORM SUBMISSION STARTED ===");
                    console.log("Form values:", values);
                    console.log("Business ID:", businessId);
                    console.log("Selected configurations:", selectedConfigurations);
                    console.log("Processor commissions:", processorCommissions);
                    console.log("Processor availability:", processorAvailability);
                    
                    let data = values;
                    data['plan_fee'] = data.plan_fee ? data.plan_fee.toString().replace(',', '.') : '';
                    data["name"] = values.businessfantasy;
                    data["minimum_credit_balance"] = values.minimum_credit_balance !== "" ? values.minimum_credit_balance : 0;
                    // For edit, we don't need to set status_business as it's already set
                    data["plan_price"] = planPrice;
                    
                    // Set plan_period based on accreditation frequency
                    if (values.accreditation_type === "Automatico") {
                      if (values.accreditation_frequency === "Principio de mes") {
                        data["plan_period"] = 30; // Monthly
                        data["days_to_credit"] = [];
                      } else if (values.accreditation_frequency === "Días personalizados") {
                        data["plan_period"] = 0; // Custom
                      }
                    } else {
                      // Manual: no automatic break schedule
                      delete data.plan_period;
                      data["days_to_credit"] = [];
                    }
                    
                    // Convert manual_crediting to boolean
                    data["manual_crediting"] = values.accreditation_type === "Manual";
                    
                    let products_plan_edit_detail = [];
                    let products_plan_edit = [...new Set(values.products_plan || [])];
                    products_plan_edit.map((product) => {
                      let productInitial = productsPlanInitial.find(pro => pro.id == product)
                      let price = values[`${productInitial?.name?.toLowerCase().replaceAll(" ", "_")}_price`]
                      let fee = values.plan_fee
                      products_plan_edit_detail.push({ method_id: product, price: price, fee: fee })
                    })
                    data["products_plan_edit_detail"] = products_plan_edit_detail;
                    
                    // Generate processors payload - ONLY selected processors from form
                    console.log("=== GENERATING PROCESSORS PAYLOAD (EDIT) ===");
                    console.log("selectedConfigurations:", selectedConfigurations);
                    console.log("Available processors:", processorsData.processors);
                    console.log("processorCommissions:", processorCommissions);
                    console.log("processorAvailability:", processorAvailability);
                    
                    const processorsPayload = [];
                    console.log("=== PROCESSING INDIVIDUAL PROCESSORS ===");
                    Object.entries(selectedConfigurations).forEach(([processorName, config]) => {
                      console.log(`Processing processor: ${processorName} with config: ${config}`);
                      if (config && config !== '' && config !== 'ninguno') {
                        const processor = processorsData.processors?.find(p => {
                          const nameMatch = p.name.toLowerCase() === processorName;
                          let configMatch = false;
                          if (config === 'directo') {
                            configMatch = !p.configuration || p.configuration.trim() === '';
                          } else {
                            configMatch = (p.configuration || '').toLowerCase() === config;
                          }
                          return nameMatch && configMatch;
                        });
                        if (processor) {
                          const processorPayload = {
                            id: processor.id,
                            processor_commission: processorCommissions[processorName] || processor.fee,
                            availability: processorAvailability[processorName] || processor.availability_input || processor.availability
                          };
                          console.log(`Adding processor to payload:`, processorPayload);
                          console.log(`Processor details:`, processor);
                          processorsPayload.push(processorPayload);
                        } else {
                          console.log(`No matching processor found for ${processorName} with config ${config}`);
                        }
                      } else {
                        console.log(`Skipping processor ${processorName} - config is empty or 'ninguno'`);
                      }
                    });
                    
                    console.log("=== FINAL PROCESSORS PAYLOAD (EDIT) ===");
                    console.log("Only selected processors:", processorsPayload);
                    
                    // Validate for duplicate processor configurations
                    console.log("=== VALIDATING FOR DUPLICATE PROCESSORS ===");
                    const processorConfigurations = {};
                    let hasDuplicates = false;
                    
                    processorsPayload.forEach(processor => {
                      const processorData = processorsData.processors?.find(p => p.id === processor.id);
                      if (processorData) {
                        const key = `${processorData.name.toLowerCase()}_${processorData.configuration || 'directo'}`;
                        if (processorConfigurations[key]) {
                          hasDuplicates = true;
                        } else {
                          processorConfigurations[key] = processor;
                        }
                      }
                    });
                    
                    if (hasDuplicates) {
                      setErrors({ 
                        processors: "No se puede guardar el mismo procesador con diferentes configuraciones. Cada procesador debe tener una configuración única." 
                      });
                      setSubmitting(false);
                      return;
                    }

                    const planHasSubscription = (values.products_plan || []).some((pid) => {
                      const pr = productsPlanInitial.find((x) => x.id == pid);
                      return pr && (pr.name === "Suscripción" || pr.name === "Suscripcion");
                    });
                    if (planHasSubscription) {
                      const hasPagoparConfig = Object.values(selectedConfigurations).some(
                        (c) => c && String(c).toLowerCase() === "pagopar"
                      );
                      if (hasPagoparConfig) {
                        setErrors({ processors: SUBSCRIPTION_PAGOPAR_INCOMPATIBLE });
                        setSubmitting(false);
                        return;
                      }
                    }
                    
                    // Replace the old processors array with the new structure
                    // IMPORTANT: This should ONLY contain processors selected in the form
                    // The backend should NOT add any processors with default=true
                    data["processors"] = processorsPayload;
                    setPayloadData(JSON.stringify(data, null, 2));
                    
                    // Update original data with processors if not already set
                    if (originalData && (!originalData.processors || originalData.processors.length === 0)) {
                        const updatedOriginalData = {
                            ...originalData,
                            processors: processorsPayload
                        };
                        setOriginalData(updatedOriginalData);
                        console.log("=== UPDATED ORIGINAL DATA WITH PROCESSORS ===", updatedOriginalData);
                    }
                    
                    // Check for changes before submitting
                    const changesDetected = detectChanges(data);
                    console.log("=== CHANGE DETECTION RESULT ===", changesDetected);
                    
                    if (!changesDetected) {
                        console.log("=== NO CHANGES DETECTED - ABORTING SUBMISSION ===");
                        setSubmitting(false);
                        alert("No se detectaron cambios en los datos. No es necesario actualizar.");
                        return;
                    }
                    
                    console.log("=== CHANGES DETECTED - PROCEEDING WITH SUBMISSION ===");
                    
                    let validationResult = true;
                    try {
                      validationResult = validateNetCommissions(values);
                    } catch (error) {
                      validationResult = false;
                    }
                    
                    if (!validationResult) {
                      setErrors({ 
                        processors: "La comisión neta no puede ser negativa para ningún método de pago seleccionado" 
                      });
                      setSubmitting(false);
                      return;
                    }
                    
                    setSubmitting(true);

                    try{
                      delete data.user;
                      dispatch(
                        actions({
                          url: `customer_business/edit_business/${businessId}/`,
                          token: auth.token,
                          action: "update",
                          data: data,
                        })
                      );
                      setPressButtonSubmit(true);
                    } catch (error) {
                      const message =
                        "Algo salió mal en el servidor, verifique los campos y vuelva a intentarlo";
                      setStatus({ success: false });
                      setErrors({ submit: message });
                      setSubmitting(false);
                      alert(message);
                    }
                  }}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    setFieldValue,
                    values,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      {/* Business Information Section */}
                      <Typography variant="h6" gutterBottom>
                        1. Datos Básicos:
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Nombre Fantasía"
                            name="businessfantasy"
                            value={values.businessfantasy}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.businessfantasy && errors.businessfantasy)}
                            helperText={touched.businessfantasy && errors.businessfantasy}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Razón Social"
                            name="businesssocial"
                            value={values.businesssocial}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.businesssocial && errors.businesssocial)}
                            helperText={touched.businesssocial && errors.businesssocial}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="RUC"
                            name="businessruc"
                            value={values.businessruc}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.businessruc && errors.businessruc)}
                            helperText={touched.businessruc && errors.businessruc}
                          />
                        </Grid>
                      </Grid>
                      <br/>
                      <br/>
                      {/* Products Plan Section */}
                      <Typography variant="h6" gutterBottom>
                        2. Productos:
                      </Typography>
                      <Typography
                            style={{
                              fontSize: 12,
                              color: "rgba(0, 0, 0, 0.6)",
                              marginBottom: '20px'
                            }}
                          >
                            Seleccione el/los productos a incluir en el plan
                          </Typography>
                          <FormControl
                            component="fieldset"
                            error={errors.products_plan && touched.products_plan}
                          >
                            <Grid container spacing={3}>
                           
                              {productsPlanInitial.map((product, i) => {
                                // Check if this is the QR product (Cobro Rápido)
                                const isQRProduct = product.name === 'Cobro Rápido' || product.description === 'QR + Links de Pago';
                                
                                return (
                                  <Grid item xs={12} md={12} key={i}>
                                  <Paper>
                                    <Grid container spacing={2} alignItems="center">
                                      <Grid item xs={1}>
                                        <Checkbox
                                          name="products_plan"
                                          type="checkbox"
                                          checked={isQRProduct ? true : (
                                            values.products_plan?.filter(
                                              (p) => p == product?.id
                                            ).length > 0
                                          )} // Always checked for QR product, otherwise check if in values.products_plan
                                          disabled={isQRProduct} // Disabled for QR product
                                          onChange={(e) => {
                                            console.log("=== CHECKBOX CHANGED ===");
                                            console.log("Product:", product.name, "ID:", product.id);
                                            console.log("Checked:", e.target.checked);
                                            console.log("Current productsPlan:", productsPlan);
                                            console.log("Current values.products_plan:", values.products_plan);
                                            
                                            // Only allow changes for non-QR products
                                            if (!isQRProduct) {
                                              const value = e.target.checked
                                                ? product.id
                                                : null;
                                              let newProductsPlan = [];
                                              if (value) {
                                                if (
                                                  values.products_plan.filter(
                                                    (pp) => pp == product.id
                                                  ).length == 0
                                                ) {
                                                  newProductsPlan = [...values.products_plan];
                                                  newProductsPlan.push(value);
                                                  console.log("Adding product, newProductsPlan:", newProductsPlan);
                                                  setFieldValue(
                                                    "products_plan",
                                                    newProductsPlan
                                                  );
                                                  setProductsPlan(newProductsPlan);
                                                }
                                              } else {
                                                newProductsPlan =
                                                  values.products_plan.filter(
                                                    (pp) => pp != product.id
                                                  );
                                                console.log("Removing product, newProductsPlan:", newProductsPlan);
                                                setFieldValue(
                                                  "products_plan",
                                                  newProductsPlan
                                                );
                                                setProductsPlan(newProductsPlan);
                                              }
                                              calculatePrice(newProductsPlan);
                                            }
                                          }}
                                          onBlur={handleBlur}
                                        />
                                      </Grid>
                            
                                      <Grid item xs={11}>
                                        <Grid container spacing={2}>
                                          <Grid item xs={6}>
                                            <TextField
                                              label="Nombre"
                                              value={product.description}
                                              InputProps={{
                                                readOnly: true,
                                              }}
                                              variant="standard"
                                              fullWidth
                                            />
                                          </Grid>
                                           <Grid item xs={6}>
                                             <NumberFormat
                                               label="Precio mensual"
                                               id={`${product.name
                                                 .toLowerCase()
                                                 .replaceAll(" ", "_")}_price`}
                                               name={`${product.name
                                                 .toLowerCase()
                                                 .replaceAll(" ", "_")}_price`}
                                               customInput={TextField}
                                               thousandSeparator={"."}
                                               decimalSeparator={false}
                                               value={
                                                 values[
                                                   `${product.name
                                                     .toLowerCase()
                                                     .replaceAll(" ", "_")}_price`
                                                 ]
                                               }
                                               InputProps={{
                                                 startAdornment: (
                                                   <InputAdornment position="start">
                                                     Gs.
                                                   </InputAdornment>
                                                 ),
                                               }}
                                               fullWidth
                                               disabled={!isQRProduct && (
                                                 productsPlan?.filter(
                                                   (p) => p == product?.id
                                                 ).length === 0
                                               )} // Disable if not QR product and not checked
                                               onChange={(e) => {
                                                 setFieldValue(
                                                   `${product.name
                                                     .toLowerCase()
                                                     .replaceAll(" ", "_")}_price`,
                                                   e.target.value.replace(".", "")
                                                 );
                                                 calculatePrice(values.products_plan);
                                               }}
                                             />
                                           </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Paper>
                                </Grid>
                              );
                              })}
                            </Grid>
                            {errors.products_plan && touched.products_plan && (
                              <FormHelperText>
                                {errors.products_plan}
                              </FormHelperText>
                            )}
                          </FormControl>
                          <Grid container spacing={3} style={{ marginTop: '20px' }}>
                            <Grid item xs={12} md={6}>
                              <Paper>
                                <Typography
                                  style={{
                                    fontSize: 12,
                                    color: "rgba(0, 0, 0, 0.6)",
                                    marginBottom: '8px'
                                  }}
                                >
                                  Total mensual
                                </Typography>
                                  <NumberFormat
                                    
                                    customInput={TextField}
                                    thousandSeparator={"."}
                                    decimalSeparator={false}
                                    value={planPrice}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          Gs
                                        </InputAdornment>
                                      ),
                                    }}
                                    fullWidth
                                    disabled
                                  />
                            </Paper>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Paper>
                                <Typography
                                  style={{
                                    fontSize: 12,
                                    color: "rgba(0, 0, 0, 0.6)",
                                    marginBottom: '8px'
                                  }}
                                >
                                  Comisión: 2.2% | Gastos Administrativos: 3.3%
                                </Typography>
                                <TextField
                                  
                                  value="5,5"
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        %
                                      </InputAdornment>
                                    ),
                                    readOnly: true,
                                  }}
                                  fullWidth
                                />
                              </Paper>
                            </Grid>
                          </Grid>



                      <br/>
                      <br/>

                      {/* Processors Section */}
                      <Typography variant="h6" gutterBottom>
                        3. Metodos de Pago
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <FormControl fullWidth>
                            <Typography
                              style={{
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.6)",
                                marginBottom: '20px'
                              }}
                            >
                              Configure los procesadores de pago y sus comisiones
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={2}>
                                
                              </Grid>
                              <Grid item xs={2}>
                              <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                  Procesadora
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                  % Comisión a cliente
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                  % Comisión neta
                                </Typography>
                              </Grid>
                              <Grid item xs={2}>
                                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                  Hs Disponibilidad
                                </Typography>
                              </Grid>
                            </Grid>
                            {(() => {
                              
                              // Filter to only show default processors
                              const defaultProcessors = processorsData.processors?.filter(p => p.default === true) || [];
                              
                              return defaultProcessors && defaultProcessors.length > 0;
                            })() ? (
                              Object.entries(
                                (processorsData.processors?.filter(p => p.default === true) || []).reduce((acc, processor) => {
                                  const normalizedName = processor.name.toLowerCase();
                                  if (!acc[normalizedName]) {
                                    acc[normalizedName] = [];
                                  }
                                  acc[normalizedName].push(processor);
                                  return acc;
                                }, {})
                              )
                              .sort(([a], [b]) => {
                                // Custom order for payment methods
                                const order = [
                                  'bancard',
                                  'bancardqr', 
                                  'tigo',
                                  'personal',
                                  'zimple',
                                  'pix',
                                  'wally',
                                  'wepa',
                                  'giros claro'
                                ];
                                
                                const indexA = order.indexOf(a);
                                const indexB = order.indexOf(b);
                                
                                // If both are in the order array, sort by their position
                                if (indexA !== -1 && indexB !== -1) {
                                  return indexA - indexB;
                                }
                                // If only A is in the order array, A comes first
                                if (indexA !== -1) {
                                  return -1;
                                }
                                // If only B is in the order array, B comes first
                                if (indexB !== -1) {
                                  return 1;
                                }
                                // If neither is in the order array, sort alphabetically
                                return a.localeCompare(b);
                              })
                              .map(([normalizedName, processors]) => {
                                // Use the component state that was set from the direct API call
                                const selectedConfig = selectedConfigurations[normalizedName] || '';
                                
                                const selectedProcessor = processors.find(p => {
                                  const configMatch = selectedConfig === 'directo' 
                                    ? (!p.configuration || p.configuration.trim() === '')
                                    : (p.configuration || '').toLowerCase() === selectedConfig;
                                  return configMatch;
                                });

                                return (
                                  <Grid container spacing={2} key={normalizedName} style={{ marginBottom: '10px', marginTop: '10px' }}>
                                    <Grid item xs={2}>
                                      <Typography variant="body2">
                                        {processors[0].name.toLowerCase() === 'bancard' ? 'Tarjetas' : 
                                         processors[0].name.toLowerCase() === 'bancarqr' ? 'QR' : 
                                         processors[0].name.toLowerCase() === 'bancardqr' ? 'QR' : 
                                         processors[0].name}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                      <FormControl size="small" fullWidth>
                                        <Select
                                          value={selectedConfig}
                                          onChange={(e) => {
                                            const selectedConfigValue = e.target.value;
                                            setSelectedConfigurations(prev => ({
                                              ...prev,
                                              [normalizedName]: selectedConfigValue
                                            }));
                                            
                                            // Auto-fill commission field when processor is selected, or clear when "Ninguno"
                                            if (selectedConfigValue) {
                                              const selectedProcessor = processors.find(p => {
                                                const configMatch = selectedConfigValue === 'directo' 
                                                  ? (!p.configuration || p.configuration.trim() === '')
                                                  : (p.configuration || '').toLowerCase() === selectedConfigValue;
                                                return configMatch;
                                              });
                                              
                                              if (selectedProcessor && selectedProcessor.fee !== undefined) {
                                                setProcessorCommissions(prev => ({
                                                  ...prev,
                                                  [normalizedName]: selectedProcessor.fee
                                                }));
                                              }
                                            } else {
                                              // Clear commission and availability fields when "Ninguno" is selected
                                              setProcessorCommissions(prev => {
                                                const newState = { ...prev };
                                                delete newState[normalizedName];
                                                return newState;
                                              });
                                              setProcessorAvailability(prev => {
                                                const newState = { ...prev };
                                                delete newState[normalizedName];
                                                return newState;
                                              });
                                            }
                                          }}
                                          displayEmpty
                                        >
                                          <MenuItem value="">
                                            <em>Ninguno</em>
                                          </MenuItem>
                                          {[...new Set(processors.map(p => p.configuration || 'directo'))].map(config => {
                                            const getDisplayName = (configName) => {
                                              if (!configName || configName.trim() === '' || configName === 'directo') return 'Directo';
                                              const normalized = configName.toLowerCase();
                                              if (normalized === 'multibuy') return 'Bancard';
                                              if (normalized === 'pagopar') return 'Pago Par';
                                              if (normalized === 'bancarqr') return 'QR';
                                              if (normalized === 'bancardqr') return 'QR';
                                              return configName;
                                            };
                                            const planHasSubscription = (values.products_plan || []).some((pid) => {
                                              const pr = productsPlanInitial.find((x) => x.id == pid);
                                              return pr && (pr.name === "Suscripción" || pr.name === "Suscripcion");
                                            });
                                            const isPagoparOption = String(config || "").toLowerCase() === "pagopar";
                                            
                                            return (
                                              <MenuItem
                                                key={config}
                                                value={config.toLowerCase()}
                                                disabled={planHasSubscription && isPagoparOption}
                                              >
                                                {getDisplayName(config)}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                      <TextField
                                        size="small"
                                        fullWidth
                                        placeholder="0.0"
                                        value={selectedConfig ? (processorCommissions[normalizedName] !== undefined ? processorCommissions[normalizedName] : (selectedProcessor ? (selectedProcessor.fee || '') : '')) : ''}
                                        onChange={(e) => {
                                          const value = e?.target?.value;
                                          const key = normalizedName;
                                          if (value !== undefined && key) {
                                            setProcessorCommissions(prev => {
                                              const newState = { ...prev };
                                              newState[key] = value;
                                              return newState;
                                            });
                                          }
                                        }}
                                        InputProps={{
                                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={3}>
                                      <TextField
                                        size="small"
                                        fullWidth
                                        placeholder="0.0"
                                        disabled={true}
                                        value={selectedConfig ? (() => {
                                          if (!selectedProcessor) return '';
                                          let productCommission = 0;
                                          if (values && values.plan_fee !== undefined && values.plan_fee !== null) {
                                            const planFeeValue = typeof values.plan_fee === 'string' 
                                              ? parseFloat(values.plan_fee.replace(',', '.')) 
                                              : parseFloat(values.plan_fee);
                                            productCommission = planFeeValue || 0;
                                          }
                                          const userCommission = processorCommissions[normalizedName];
                                          const processorCommission = userCommission !== undefined ? parseFloat(userCommission) : (selectedProcessor ? (selectedProcessor.fee || 0) : 0);
                                          const netCommission = productCommission - processorCommission;
                                          return netCommission.toFixed(1);
                                        })() : ''}
                                        InputProps={{
                                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={2}>
                                      <TextField
                                        size="small"
                                        fullWidth
                                        placeholder="0"
                                        disabled={true}
                                        value={selectedConfig ? (processorAvailability[normalizedName] || (() => {
                                          if (!selectedProcessor) return '';
                                          const duration = selectedProcessor.availability_input || selectedProcessor.availability;
                                          if (!duration) return '';
                                          return duration;
                                        })()) : ''}
                                        onChange={(e) => {
                                          const value = e?.target?.value;
                                          const key = normalizedName;
                                          if (value !== undefined && key) {
                                            const finalValue = value === '' ? '0' : value;
                                            setProcessorAvailability(prev => {
                                              const newState = { ...prev };
                                              newState[key] = finalValue;
                                              return newState;
                                            });
                                          }
                                        }}
                                        InputProps={{
                                          endAdornment: <InputAdornment position="end">hs</InputAdornment>,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                );
                              })
                            ) : (
                              <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                  No hay procesadores disponibles
                                </Typography>
                              </Grid>
                            )}
                            {errors.processors && touched.processors && (
                              <FormHelperText>
                                {errors.processors}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>

                      <br/>
                      <br/>

                      {/* Accreditation Type Section */}
                      <Typography variant="h6" gutterBottom>
                        5. Retiro de Dinero
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.accreditation_type && errors.accreditation_type)}
                          >
                            <InputLabel>Tipo de acreditación</InputLabel>
                            <Select
                              name="accreditation_type"
                              value={values.accreditation_type}
                              onChange={(e) => {
                                setAccreditationType(e.target.value);
                                setFieldValue("accreditation_type", e.target.value);
                                // Update manual_crediting based on accreditation type
                                setManualCrediting(e.target.value === "Manual");
                                setFieldValue("manual_crediting", e.target.value === "Manual");
                                // Set minimum balance to 100,000 when Manual is selected
                                if (e.target.value === "Manual") {
                                  setMinimumBalance("100000");
                                  setFieldValue("minimum_credit_balance", 100000);
                                  setDaysToCredit([]);
                                  setFieldValue("days_to_credit", []);
                                  // Force validation to re-run after setting the value
                                  setTimeout(() => {
                                    setFieldValue("minimum_credit_balance", 100000);
                                  }, 50);
                                } else {
                                  // Reset to 0 when not Manual
                                  setMinimumBalance("0");
                                  setFieldValue("minimum_credit_balance", 0);
                                }
                              }}
                              onBlur={handleBlur}
                            >
                              <MenuItem value="Automatico">Automático</MenuItem>
                              <MenuItem value="Manual">Manual</MenuItem>
                            </Select>
                            {touched.accreditation_type && errors.accreditation_type && (
                              <FormHelperText>{errors.accreditation_type}</FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        
                        {/* Only show minimum credit balance when Manual is selected */}
                        {accreditationType === "Manual" && (
                          <Grid item xs={12} sm={6}>
                            <NumberFormat
                              customInput={TextField}
                              label="Saldo mínimo para acreditación"
                              name="minimum_credit_balance"
                              value={values.minimum_credit_balance}
                              thousandSeparator="."
                              decimalSeparator={false}
                              prefix="Gs "
                              suffix=""
                              onValueChange={(values) => {
                                const numericValue = parseInt(values.value.replace(/\./g, ''));
                                setFieldValue("minimum_credit_balance", numericValue);
                                setMinimumBalance(numericValue.toString());
                              }}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\./g, '');
                                const numericValue = parseInt(value) || 0;
                                setFieldValue("minimum_credit_balance", numericValue);
                                setMinimumBalance(numericValue.toString());
                              }}
                              error={Boolean(touched.minimum_credit_balance && errors.minimum_credit_balance)}
                              helperText={touched.minimum_credit_balance && errors.minimum_credit_balance}
                              fullWidth
                            />
                          </Grid>
                        )}
                      </Grid>

                      {/* Radio buttons for Automatico - only show when Automatico is selected */}
                      {accreditationType === "Automatico" && (
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <FormControl component="fieldset">
                              <FormGroup row>
                                <FormControlLabel
                                  control={
                                    <Radio
                                      checked={accreditationFrequency === "Principio de mes"}
                                      onChange={(e) => {
                                        setAccreditationFrequency(e.target.value);
                                        setFieldValue("accreditation_frequency", e.target.value);
                                      }}
                                      value="Principio de mes"
                                      name="accreditation_frequency"
                                    />
                                  }
                                  label="Principio de mes"
                                />
                                <FormControlLabel
                                  control={
                                    <Radio
                                      checked={accreditationFrequency === "Días personalizados"}
                                      onChange={(e) => {
                                        setAccreditationFrequency(e.target.value);
                                        setFieldValue("accreditation_frequency", e.target.value);
                                      }}
                                      value="Días personalizados"
                                      name="accreditation_frequency"
                                    />
                                  }
                                  label="Días personalizados"
                                />
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}

                      {/* Days to Credit Section - only show when Automatico and Días personalizados is selected */}
                      {accreditationType === "Automatico" && accreditationFrequency === "Días personalizados" && (
                        <>
                          <Divider my={4} />
                          <Typography variant="h6" gutterBottom>
                            Días de Acreditación Personalizada
                          </Typography>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <FormControl
                                component="fieldset"
                                error={errors.days_to_credit && touched.days_to_credit}
                              >
                                <Typography
                                  style={{
                                    fontSize: 10,
                                    color: "rgba(0, 0, 0, 0.38)",
                                  }}
                                >
                                  Seleccione el/los día(s) de acreditación personalizada
                                </Typography>
                                <FormGroup
                                  aria-label="position"
                                  row
                                  id="checkbox-group"
                                >
                                  {days_week.map((d, i) => (
                                    <FormControlLabel
                                      key={i}
                                      role="group"
                                      aria-labelledby="checkbox-group"
                                      control={
                                        <Checkbox
                                          name="days_to_credit"
                                          type="checkbox"
                                          style={{ paddingTop: 0 }}
                                          checked={(() => {
                                            const formikValue = values.days_to_credit?.includes(d.id);
                                            const stateValue = daysToCredit?.includes(d.id);
                                            console.log(`Day ${d.id} (${d.name}): formik=${formikValue}, state=${stateValue}, values.days_to_credit=`, values.days_to_credit, 'daysToCredit=', daysToCredit);
                                            return formikValue || stateValue || false;
                                          })()}
                                          onChange={(e) => {
                                            const value = e.target.checked ? d.id : null;
                                            let newDaysToCredit = [];
                                            if (value) {
                                              if (
                                                values.days_to_credit?.filter(
                                                  (dtc) => dtc == d.id
                                                ).length == 0
                                              ) {
                                                newDaysToCredit = values.days_to_credit || [];
                                                newDaysToCredit.push(value);
                                                setFieldValue("days_to_credit", newDaysToCredit);
                                                setDaysToCredit(newDaysToCredit);
                                              }
                                            } else {
                                              newDaysToCredit =
                                                values.days_to_credit?.filter(
                                                  (dtc) => dtc != d.id
                                                ) || [];
                                              setFieldValue("days_to_credit", newDaysToCredit);
                                              setDaysToCredit(newDaysToCredit);
                                            }
                                          }}
                                          onBlur={handleBlur}
                                        />
                                      }
                                      label={d.name}
                                    />
                                  ))}
                                </FormGroup>
                                {errors.days_to_credit && touched.days_to_credit && (
                                  <FormHelperText>
                                    {errors.days_to_credit}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      <br/>
                      <br/>

                      {/* Bank Statement Name Section */}
                      <Typography variant="h6" gutterBottom>
                        6. Nombre en extracto bancario
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item md={12}>
                          <Typography
                            style={{
                              fontSize: 10,
                              color: "rgba(0, 0, 0, 0.38)",
                              marginTop: 8,
                            }}
                          >
                            Bancard
                          </Typography>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item>
                              <Select
                                label="Bancard"
                                value={bancardModification}
                                onChange={(e) => {
                                  setBancardModification(e.target.value);
                                  setFieldValue("bancard_modification", e.target.value);
                                }}
                                displayEmpty
                                size="small"
                                style={{ minWidth: 120 }}
                              >
                                <MenuItem value="No Modifica">No Modifica</MenuItem>
                                <MenuItem value="Modifica">Modifica</MenuItem>
                              </Select>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* Show input fields only when "Modifica" is selected */}
                        {bancardModification === "Modifica" && (
                          <>
                            <Grid item md={3}>
                              <TextField
                                margin="dense"
                                id="store_id"
                                key="store_id"
                                label="Store ID"
                                type="text"
                                fullWidth
                                name="store_id"
                                value={values.store_id}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      #
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item md={3}>
                              <TextField
                                margin="dense"
                                id="store_branch"
                                key="store_branch"
                                label="Store Branch"
                                type="text"
                                fullWidth
                                name="store_branch"
                                value={values.store_branch}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      #
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item md={6}>
                              <TextField
                                margin="dense"
                                id="store_name"
                                key="store_name"
                                label="Store Name"
                                type="text"
                                fullWidth
                                name="store_name"
                                value={values.store_name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      #
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>

                      <br/>
                      <br/>


                      {/* Submit Buttons */}
                      <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                        spacing={2}
                        style={{ paddingTop: "20px" }}
                      >
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={isSubmitting || isFeeError || !hasChanges}
                          >
                            {isSubmitting ? "Actualizando..." : hasChanges ? "Actualizar" : "Sin cambios"}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            color="primary"
                            variant="outlined"
                            component={Linkto}
                            to={{
                              pathname: backUrl,
                              state: {
                                datas: filterApplieds,
                              },
                            }}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
              ) : (
                <p>Cargando datos...</p>
              )}
            </Paper>
          </Grid>
        </Grid>

        <Dialog
          disableBackdropClick
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          PaperComponent={PaperComponent}
          style={{ minWidth: 600 }}
        >
          <DialogTitle id="form-dialog-title">Aviso</DialogTitle>
          <Divider my={1} />
          <DialogContent>
            <Typography variant="h6" gutterBottom display="inline">
              Datos actualizados exitosamente.
            </Typography>
          </DialogContent>
          <Divider my={3} />
          <DialogActions>
            <Button
              color="primary"
              component={Linkto}
              to={{
                pathname: backUrl,
                state: {
                  datas: filterApplieds,
                },
              }}
            >
              Aceptar y Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    )
  );
}

export default CustomerBusinessEdit;